import { APP_NAME } from '@/config/appConstants'

export const AppConfig = {
  site_name: APP_NAME,
  title: `Huracán for ${APP_NAME}`,
  description: `Base code for Huracán by ${APP_NAME}.`,
  locale: 'en',
}
